<button color="primary" matButton="elevated" (click)="toggleNewFeatureForm()">
    Neues Merkmal anlegen
</button>
<div *ngIf="showNewFeature">
    <app-common-feature-item-edit-form [commonFeature]="commonFeature"
        (close)="onCloseEdit($event)"></app-common-feature-item-edit-form>
</div>